<!--
 * @description:
 * @author: cuicui
 * @Date: 2023-01-20 10:33:02
 * @LastEditTime: 2023-01-30 23:05:09
 * @LastEditors: cuicui
-->
<template>
    <div>
        <page-title title="基本信息">
            <el-descriptions :column="2">
                <el-descriptions-item label="案件名称">{{formOptions.caseName}}</el-descriptions-item>
                <el-descriptions-item label="联系单位/个人姓名">{{formOptions.contacter}}</el-descriptions-item>
                <el-descriptions-item label="联系电话">{{formOptions.phone}}</el-descriptions-item>
                <el-descriptions-item label="邮箱">{{formOptions.email}}</el-descriptions-item>
            </el-descriptions>
        </page-title>
        <page-title title="案情信息">
            <el-descriptions :column="2">
                <el-descriptions-item label="基本案情">{{formOptions.caseDetail}}</el-descriptions-item>
            </el-descriptions>
        </page-title>
        <page-title title="证据包下载链接">
            <el-row>
                <el-link type="primary" @click='downloadFile(formOptions.eviUrl)'>点击下载证据包</el-link>
            </el-row>
        </page-title>
        <page-title title="所需服务">
            <el-row>
                <el-col style="font-size: 12px;">{{formOptions.serviceType.value}}</el-col>
            </el-row>
        </page-title>
        <page-title title="处理意见">
            <el-input v-model="feedback"  show-word-limit :maxlength="500"
             :disabled="statusList.includes(formOptions.status)" type="textarea" :row="3"></el-input>
            <div style="margin-top: 10px;">
                <el-button v-if="!statusList.includes(formOptions.status)" @click="updateFun('ERROR')" type="primary">拒绝</el-button>
                <el-button v-if="!statusList.includes(formOptions.status)" @click="updateFun('SUCCESS')" type="primary">接受</el-button>
                <el-button v-if="!statusList.includes(formOptions.status)" @click="updateFun('ENTRUST')" type="primary">委托其他律所</el-button>
                <el-button @click="$router.go(-1)">关闭</el-button>
            </div>
        </page-title>
    </div>
</template>

<script>
  import {bqwqUpdate} from '@/api/req';
  import PageTitle from '@/components/pageTitle.vue';
  import download from "downloadjs";
export default {
   mixins:[],
   components:{
    PageTitle
   },
   props:{},
   watch: {},
   computed: {},
   data() {
       return {
            statusList: ['ERROR', 'ENTRUST', 'SUCCESS'],
            formOptions: {

            },
            feedback: ""
       }
   },
   created() {
        this.formOptions = this.$route.query.detail ? JSON.parse(this.$route.query.detail) : {};
        this.formOptions.feedback = this.formOptions.feedback === 'undefined' || !this.formOptions.feedback
        ?  '' : this.formOptions.feedback;
        this.feedback = this.formOptions.feedback;
        console.log('first', {...this.formOptions})
   },
   methods: {
    downloadFile(fileAddress){
        download(fileAddress);
    },
    updateFun(status){
        this.$ajax.post(`${bqwqUpdate}?id=${this.formOptions.id}&status=${status}&feedback=${this.feedback}`, {
            status,
            feedback: this.feedback,
            id: this.formOptions.id
        }).then(res=>{
            this.$message({
                showClose:true,
                message:'更新成功',
                type:'success',
                center:true,
                duration:3000
            })
            setTimeout(() => {
                this.$router.go(-1);
            }, 500);
        })
    },
   },
   mounted() {},
   updated() {},
   destroyed() {},
}
</script>
<style lang='scss' scoped>
</style>
